import { CountyResolution, CountyResolutionStatus } from 'types';

/*
 * Unresolved states are shown rather than hidden: a blank county and a county GLIDE could not
 * determine look identical otherwise, and reviewers in NY and MA need to tell them apart.
 */
const unresolvedLabels: Record<Exclude<CountyResolutionStatus, CountyResolutionStatus.resolved>, string> = {
  [CountyResolutionStatus.notFound]: 'No county found for this address',
  [CountyResolutionStatus.ambiguous]: 'Could not be determined',
  [CountyResolutionStatus.noCoordinates]: 'Address could not be located',
  [CountyResolutionStatus.unverifiedCoordinates]: 'Location does not match the address',
  [CountyResolutionStatus.pending]: 'Pending',
};

export const formatCountyResolution = (countyResolution: CountyResolution | undefined): string => {
  if (!countyResolution) {
    return 'Not resolved';
  }

  if (countyResolution.status === CountyResolutionStatus.resolved) {
    return countyResolution.name ?? 'Not resolved';
  }

  return unresolvedLabels[countyResolution.status];
};
